import { useState } from 'react';
import { Link, usePage } from '@inertiajs/react';
import { Box, Paper, Typography } from '@mui/material';

export default function AuthSimpleLayout({ children, title, description }) {
    const { isBaseDomain, company_name, company_logo } = usePage().props;
    // A logo set in settings but missing from storage would render a broken-image
    // icon; fall back to the company name instead.
    const [logoFailed, setLogoFailed] = useState(false);

    return (
        <Box sx={{
            display: 'flex',
            minHeight: '100vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'grey.100',
            p: { xs: 3, md: 5 },
        }}>
            <Paper sx={{ width: '100%', maxWidth: 400, p: 4, pt: 5, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, width: '100%' }}>
                        {(!isBaseDomain && company_logo && !logoFailed) ? (
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                <Link href={route('home')} style={{ textDecoration: 'none' }}>
                                    <img
                                        src={company_logo}
                                        alt={company_name || 'Logo'}
                                        onError={() => setLogoFailed(true)}
                                        style={{ maxHeight: 64, maxWidth: 240, objectFit: 'contain' }}
                                    />
                                </Link>
                            </Box>
                        ) : (
                            <Link href={route('home')} style={{ textDecoration: 'none' }}>
                                <Typography variant="h4" fontWeight={700} sx={{ textTransform: 'uppercase', color: 'text.primary' }}>
                                    {isBaseDomain ? 'PROSANO' : (company_name || 'SSM')}
                                </Typography>
                            </Link>
                        )}

                        {title && (
                            <Box sx={{ textAlign: 'left', width: '100%' }}>
                                <Typography variant="h6" fontWeight={500}>{title}</Typography>
                                {description && (
                                    <Typography variant="body2" color="text.secondary">{description}</Typography>
                                )}
                            </Box>
                        )}
                    </Box>
                    {children}
                </Box>
            </Paper>
        </Box>
    );
}
